/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {createContext, useContext} from 'react';

/**
 * Flags whether Smarter Trailer widgets render as Asset Details drawer
 * tiles - `false` by default, so widgets rendered anywhere else keep their
 * legacy layout in every theme.
 *
 * ```typescript
 * import {AssetDetailsTileContext} from '@ion/dls/src/components/smarterTrailer/assetDetailsTileContext';
 * ...
 *
 * <AssetDetailsTileContext.Provider value={true}>
 *   <DoorStatusWidget doorStatus={doorStatus} />
 * </AssetDetailsTileContext.Provider>
 * ```
 */
export const AssetDetailsTileContext = createContext<boolean>(false);

/**
 * Determines whether a Smarter Trailer widget renders as an Asset Details
 * drawer tile.
 *
 * ```typescript
 * import {useIsAssetDetailsTile} from '@ion/dls/src/components/smarterTrailer/assetDetailsTileContext';
 * ...
 *
 * const isTile = useIsAssetDetailsTile();
 * ```
 *
 * @returns `true` when the widget sits inside an `AssetDetailsTileContext`
 *          provider, otherwise `false`.
 */
export const useIsAssetDetailsTile = (): boolean => useContext(AssetDetailsTileContext);

export default AssetDetailsTileContext;
